export type CountryStateInfo = {
  code: string;
  name: string;
  name_ru: string;
}

export const statesList: Record<'USA' | 'CAN', CountryStateInfo[]> = {
  USA: [
    { code: 'AL', name: 'Alabama', name_ru: 'Алабама' },
    { code: 'AK', name: 'Alaska', name_ru: 'Аляска' },
    { code: 'AZ', name: 'Arizona', name_ru: 'Аризона' },
    { code: 'AR', name: 'Arkansas', name_ru: 'Арканзас' },
    { code: 'CA', name: 'California', name_ru: 'Калифорния' },
    { code: 'CO', name: 'Colorado', name_ru: 'Колорадо' },
    { code: 'CT', name: 'Connecticut', name_ru: 'Коннектикут' },
    { code: 'DE', name: 'Delaware', name_ru: 'Делавэр' },
    { code: 'FL', name: 'Florida', name_ru: 'Флорида' },
    { code: 'GA', name: 'Georgia', name_ru: 'Джорджия' },
    { code: 'HI', name: 'Hawaii', name_ru: 'Гавайи' },
    { code: 'ID', name: 'Idaho', name_ru: 'Айдахо' },
    { code: 'IL', name: 'Illinois', name_ru: 'Иллинойс' },
    { code: 'IN', name: 'Indiana', name_ru: 'Индиана' },
    { code: 'IA', name: 'Iowa', name_ru: 'Айова' },
    { code: 'KS', name: 'Kansas', name_ru: 'Канзас' },
    { code: 'KY', name: 'Kentucky', name_ru: 'Кентукки' },
    { code: 'LA', name: 'Louisiana', name_ru: 'Луизиана' },
    { code: 'ME', name: 'Maine', name_ru: 'Мэн' },
    { code: 'MD', name: 'Maryland', name_ru: 'Мэриленд' },
    { code: 'MA', name: 'Massachusetts', name_ru: 'Массачусетс' },
    { code: 'MI', name: 'Michigan', name_ru: 'Мичиган' },
    { code: 'MN', name: 'Minnesota', name_ru: 'Миннесота' },
    { code: 'MS', name: 'Mississippi', name_ru: 'Миссисипи' },
    { code: 'MO', name: 'Missouri', name_ru: 'Миссури' },
    { code: 'MT', name: 'Montana', name_ru: 'Монтана' },
    { code: 'NE', name: 'Nebraska', name_ru: 'Небраска' },
    { code: 'NV', name: 'Nevada', name_ru: 'Невада' },
    { code: 'NH', name: 'New Hampshire', name_ru: 'Нью-Гэмпшир' },
    { code: 'NJ', name: 'New Jersey', name_ru: 'Нью-Джерси' },
    { code: 'NM', name: 'New Mexico', name_ru: 'Нью-Мексико' },
    { code: 'NY', name: 'New York', name_ru: 'Нью-Йорк' },
    { code: 'NC', name: 'North Carolina', name_ru: 'Северная Каролина' },
    { code: 'ND', name: 'North Dakota', name_ru: 'Северная Дакота' },
    { code: 'OH', name: 'Ohio', name_ru: 'Огайо' },
    { code: 'OK', name: 'Oklahoma', name_ru: 'Оклахома' },
    { code: 'OR', name: 'Oregon', name_ru: 'Орегон' },
    { code: 'PA', name: 'Pennsylvania', name_ru: 'Пенсильвания' },
    { code: 'RI', name: 'Rhode Island', name_ru: 'Род-Айленд' },
    { code: 'SC', name: 'South Carolina', name_ru: 'Южная Каролина' },
    { code: 'SD', name: 'South Dakota', name_ru: 'Южная Дакота' },
    { code: 'TN', name: 'Tennessee', name_ru: 'Теннесси' },
    { code: 'TX', name: 'Texas', name_ru: 'Техас' },
    { code: 'UT', name: 'Utah', name_ru: 'Юта' },
    { code: 'VT', name: 'Vermont', name_ru: 'Вермонт' },
    { code: 'VA', name: 'Virginia', name_ru: 'Вирджиния' },
    { code: 'WA', name: 'Washington', name_ru: 'Вашингтон' },
    { code: 'WV', name: 'West Virginia', name_ru: 'Западная Вирджиния' },
    { code: 'WI', name: 'Wisconsin', name_ru: 'Висконсин' },
    { code: 'WY', name: 'Wyoming', name_ru: 'Вайоминг' }
  ],
  CAN: [
    { code: 'AB', name: 'Alberta', name_ru: 'Альберта' },
    { code: 'BC', name: 'British Columbia', name_ru: 'Британская Колумбия' },
    { code: 'MB', name: 'Manitoba', name_ru: 'Манитоба' },
    { code: 'NB', name: 'New Brunswick', name_ru: 'Нью-Брансуик' },
    { code: 'NL', name: 'Newfoundland and Labrador', name_ru: 'Ньюфаундленд и Лабрадор' },
    { code: 'NS', name: 'Nova Scotia', name_ru: 'Новая Шотландия' },
    { code: 'ON', name: 'Ontario', name_ru: 'Онтарио' },
    { code: 'PE', name: 'Prince Edward Island', name_ru: 'Остров Принца Эдуарда' },
    { code: 'QC', name: 'Quebec', name_ru: 'Квебек' },
    { code: 'SK', name: 'Saskatchewan', name_ru: 'Саскачеван' },
    { code: 'NT', name: 'Northwest Territories', name_ru: 'Северо-Западные территории' },
    { code: 'NU', name: 'Nunavut', name_ru: 'Нунавут' },
    { code: 'YT', name: 'Yukon', name_ru: 'Юкон' }
  ]
};
